// Mock data for Demarre Tours

export const translations = {
  pt: {
    nav: {
      home: 'Início',
      pilgrimages: 'Peregrinações',
      about: 'Sobre Nós',
      testimonials: 'Depoimentos',
      faq: 'FAQ',
      contact: 'Contato',
      brazilDepartures: 'Saídas Brasil',
      usaDepartures: 'Saídas EUA'
    },
    hero: {
      welcome: 'BEM-VINDO A DEMARRÉ TOURS',
      subtitle: 'Uma experiência espiritual inesquecível',
      description: 'Embarque em nossas viagens de Fé',
      cta: 'Saiba mais',
      tagline: 'Peregrinar com fé é com a Demarré.'
    },
    about: {
      title: 'Sobre a Demarré Tours',
      history_title: 'Nossa História',
      history1: 'A Demarré Tours não é apenas uma empresa. Somos uma família. Essa família vem sendo formada há quase 30 anos por milhares de peregrinos que nos deram, e dão, a alegria de fazer parte de nossas viagens. E isso não foi por acaso.',
      history2: 'Após estarem trabalhando no mercado de turismo por quase 10 anos, em 1996, o casal Marcos e Claudia Demarré vinha liderando alguns grupos de oração no Rio de Janeiro e os dois sentiram muito forte o chamado de Nossa Senhora, Nossa querida Mãezinha, a unir o trabalho que tanto amavam com sua missão de evangelizar. A partir daí, nasceu a Demarré.',
      history3: 'Ao longo de todos esses anos nos especializamos cada vez mais em cada aspecto que envolve uma peregrinação e, dando atenção especial a cada peregrino, pensamos em cada detalhe para que sua única preocupação seja a de curtir sua viagem!',
      pilgrimage_title: 'Viagens de fé e peregrinações',
      description1: 'Peregrinar não é simplesmente viajar. Peregrinar é entrar numa via de transformação, de crescimento interior e de amadurecimento pessoal. É uma oportunidade de aprofundar a sua vida espiritual.',
      description2: 'Peregrinar com a Demarré é abraçar essa oportunidade e também aproveitar o melhor que uma viagem tem para oferecer: comidas típicas, visitas culturais, boas instalações hoteleiras, aprendizado com guias locais super preparados etc.',
      description3: 'A Demarré pensa em cada detalhe para que você tenha a melhor experiência, desde o 1º atendimento até o retorno para casa. Com a Demarré você encontrará lazer, cultura, espiritualidade, momentos muito fortes para aprofundar a sua fé, e muitas histórias para contar e guardar no coração e na memória!',
      cta: 'Quero a minha viagem'
    },
    tours: {
      brazil: 'Saídas Brasil',
      usa: 'Saídas EUA',
      days: 'dias',
      bookNow: 'Reserve Agora',
      viewDetails: 'Ver Detalhes'
    },
    whyChoose: {
      title: 'Por que escolher a Demarré Tours',
      reasons: [
        {
          title: 'Especialização em peregrinações católicas',
          description: 'Nosso foco é exclusivamente em peregrinações católicas, o que nos permite oferecer um conhecimento especializado e aprofundado nesse tipo de viagem.'
        },
        {
          title: 'Acompanhamento dos Guias DEMARRÉ',
          description: 'Nossos grupos são sempre acompanhados pelos Guias DEMARRÉ, que estarão presentes desde o início até o fim da viagem, garantindo assistência e orientação aos participantes.'
        },
        {
          title: 'Presença de sacerdotes católicos',
          description: 'Todos os nossos grupos contam com a presença de ao menos um sacerdote católico, que atua como diretor espiritual do grupo.'
        },
        {
          title: 'Combinação de espiritualidade e turismo',
          description: 'Oferecemos visitas e passeios culturais, jantares típicos e conhecimento histórico dos lugares visitados.'
        },
        {
          title: 'Serviços de alta qualidade a preços competitivos',
          description: 'Nos esforçamos para oferecer preços competitivos no mercado, proporcionando aos nossos clientes uma ótima relação custo-benefício.'
        },
        {
          title: 'Atendimento customizado e pessoal',
          description: 'Valorizamos cada passageiro como uma pessoa única e oferecemos atendimento personalizado.'
        }
      ]
    },
    contact: {
      title: 'Entre em Contato',
      subtitle: 'Ainda com dúvidas?',
      description: 'Perguntas sem resposta são oportunidades perdidas. Preencha o formulário agora e receba respostas personalizadas para suas dúvidas.',
      name: 'Nome',
      phone: 'Telefone',
      email: 'E-mail',
      message: 'Mensagem',
      send: 'Enviar formulário'
    },
    footer: {
      rights: 'Todos os direitos reservados',
      privacy: 'Política de privacidade'
    }
  },
  en: {
    nav: {
      home: 'Home',
      pilgrimages: 'Pilgrimages',
      about: 'About Us',
      testimonials: 'Testimonials',
      faq: 'FAQ',
      contact: 'Contact',
      brazilDepartures: 'Brazil Departures',
      usaDepartures: 'USA Departures'
    },
    hero: {
      welcome: 'WELCOME TO DEMARRÉ TOURS',
      subtitle: 'An unforgettable spiritual experience',
      description: 'Embark on our Faith Journeys',
      cta: 'Learn more',
      tagline: 'Pilgrimage with faith is with Demarré.'
    },
    about: {
      title: 'About Demarré Tours',
      history_title: 'Our Story',
      history1: 'Demarré Tours is not just a company. We are a family. This family has been formed for almost 30 years by thousands of pilgrims who have given us, and continue to give us, the joy of being part of our trips. And this was no coincidence.',
      history2: 'After working in the tourism industry for almost 10 years, in 1996, the couple Marcos and Claudia Demarré were leading prayer groups in Rio de Janeiro when they felt a strong calling from Our Lady to unite the work they loved with their mission of evangelization. From that moment, Demarré was born.',
      history3: 'Over all these years we have increasingly specialized in every aspect that involves a pilgrimage, giving special attention to each pilgrim, thinking of every detail so that your only concern is to enjoy your trip!',
      pilgrimage_title: 'Faith journeys and pilgrimages',
      description1: 'Pilgrimage is not simply traveling. Pilgrimage is entering a path of transformation, inner growth and personal maturity. It is an opportunity to deepen your spiritual life.',
      description2: 'Pilgrimage with Demarré is embracing this opportunity and also enjoying the best that a trip has to offer: typical foods, cultural visits, good hotel facilities, learning with super prepared local guides, etc.',
      description3: 'Demarré thinks of every detail so that you have the best experience, from the 1st service to the return home. With Demarré you will find leisure, culture, spirituality, very strong moments to deepen your faith, and many stories to tell and keep in your heart and memory!',
      cta: 'I want my trip'
    },
    tours: {
      brazil: 'Brazil Departures',
      usa: 'USA Departures',
      days: 'days',
      bookNow: 'Book Now',
      viewDetails: 'View Details'
    },
    whyChoose: {
      title: 'Why choose Demarré Tours',
      reasons: [
        {
          title: 'Specialization in Catholic pilgrimages',
          description: 'Our focus is exclusively on Catholic pilgrimages, which allows us to offer specialized and in-depth knowledge in this type of travel.'
        },
        {
          title: 'DEMARRÉ Guides accompaniment',
          description: 'Our groups are always accompanied by DEMARRÉ Guides, who will be present from the beginning to the end of the trip, ensuring assistance and guidance to participants.'
        },
        {
          title: 'Presence of Catholic priests',
          description: 'All our groups have the presence of at least one Catholic priest, who acts as the spiritual director of the group.'
        },
        {
          title: 'Combination of spirituality and tourism',
          description: 'We offer cultural visits and tours, typical dinners and historical knowledge of the places visited.'
        },
        {
          title: 'High quality services at competitive prices',
          description: 'We strive to offer competitive prices in the market, providing our customers with excellent value for money.'
        },
        {
          title: 'Customized and personal service',
          description: 'We value each passenger as a unique person and offer personalized service.'
        }
      ]
    },
    contact: {
      title: 'Get in Touch',
      subtitle: 'Still have questions?',
      description: 'Unanswered questions are missed opportunities. Fill out the form now and receive personalized answers to your questions.',
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      message: 'Message',
      send: 'Send form'
    },
    footer: {
      rights: 'All rights reserved',
      privacy: 'Privacy policy'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      pilgrimages: 'Peregrinaciones',
      about: 'Sobre Nosotros',
      testimonials: 'Testimonios',
      faq: 'FAQ',
      contact: 'Contacto',
      brazilDepartures: 'Salidas Brasil',
      usaDepartures: 'Salidas EE.UU.'
    },
    hero: {
      welcome: 'BIENVENIDO A DEMARRÉ TOURS',
      subtitle: 'Una experiencia espiritual inolvidable',
      description: 'Embarca en nuestros viajes de Fe',
      cta: 'Saber más',
      tagline: 'Peregrinar con fe es con Demarré.'
    },
    about: {
      title: 'Sobre Demarré Tours',
      history_title: 'Nuestra Historia',
      history1: 'Demarré Tours no es solo una empresa. Somos una familia. Esta familia se ha formado durante casi 30 años por miles de peregrinos que nos han dado, y nos dan, la alegría de formar parte de nuestros viajes. Y esto no fue por casualidad.',
      history2: 'Después de trabajar en la industria del turismo durante casi 10 años, en 1996, la pareja Marcos y Claudia Demarré lideraba grupos de oración en Río de Janeiro cuando sintieron un fuerte llamado de Nuestra Señora a unir el trabajo que tanto amaban con su misión de evangelizar. A partir de ahí, nació Demarré.',
      history3: 'A lo largo de todos estos años nos hemos especializado cada vez más en cada aspecto que involucra una peregrinación, prestando especial atención a cada peregrino, pensando en cada detalle para que su única preocupación sea disfrutar de su viaje!',
      pilgrimage_title: 'Viajes de fe y peregrinaciones',
      description1: 'Peregrinar no es simplemente viajar. Peregrinar es entrar en un camino de transformación, crecimiento interior y madurez personal. Es una oportunidad para profundizar su vida espiritual.',
      description2: 'Peregrinar con Demarré es abrazar esta oportunidad y también disfrutar de lo mejor que un viaje tiene para ofrecer: comidas típicas, visitas culturales, buenas instalaciones hoteleras, aprendizaje con guías locales súper preparados, etc.',
      description3: 'Demarré piensa en cada detalle para que tengas la mejor experiencia, desde el primer servicio hasta el regreso a casa. Con Demarré encontrarás ocio, cultura, espiritualidad, momentos muy fuertes para profundizar tu fe, y muchas historias para contar y guardar en tu corazón y memoria!',
      cta: 'Quiero mi viaje'
    },
    tours: {
      brazil: 'Salidas Brasil',
      usa: 'Salidas EE.UU.',
      days: 'días',
      bookNow: 'Reservar Ahora',
      viewDetails: 'Ver Detalles'
    },
    whyChoose: {
      title: 'Por qué elegir Demarré Tours',
      reasons: [
        {
          title: 'Especialización en peregrinaciones católicas',
          description: 'Nuestro enfoque es exclusivamente en peregrinaciones católicas, lo que nos permite ofrecer conocimiento especializado y profundo en este tipo de viaje.'
        },
        {
          title: 'Acompañamiento de Guías DEMARRÉ',
          description: 'Nuestros grupos siempre están acompañados por Guías DEMARRÉ, que estarán presentes desde el principio hasta el final del viaje.'
        },
        {
          title: 'Presencia de sacerdotes católicos',
          description: 'Todos nuestros grupos cuentan con la presencia de al menos un sacerdote católico, que actúa como director espiritual del grupo.'
        },
        {
          title: 'Combinación de espiritualidad y turismo',
          description: 'Ofrecemos visitas y tours culturales, cenas típicas y conocimiento histórico de los lugares visitados.'
        },
        {
          title: 'Servicios de alta calidad a precios competitivos',
          description: 'Nos esforzamos por ofrecer precios competitivos en el mercado, brindando a nuestros clientes una excelente relación calidad-precio.'
        },
        {
          title: 'Servicio personalizado y personal',
          description: 'Valoramos a cada pasajero como una persona única y ofrecemos un servicio personalizado.'
        }
      ]
    },
    contact: {
      title: 'Ponte en Contacto',
      subtitle: '¿Aún tienes dudas?',
      description: 'Las preguntas sin respuesta son oportunidades perdidas. Completa el formulario ahora y recibe respuestas personalizadas a tus preguntas.',
      name: 'Nombre',
      phone: 'Teléfono',
      email: 'Correo electrónico',
      message: 'Mensaje',
      send: 'Enviar formulario'
    },
    footer: {
      rights: 'Todos los derechos reservados',
      privacy: 'Política de privacidad'
    }
  }
};

export const tours = [
  {
    id: 1,
    name: { pt: 'Terra Santa', en: 'Holy Land', es: 'Tierra Santa' },
    destination: { pt: 'Israel e Palestina', en: 'Israel and Palestine', es: 'Israel y Palestina' },
    duration: 10,
    departure: 'brazil',
    price: 4200,
    image: 'https://images.unsplash.com/photo-1609137144813-7d9921338f24?w=800&q=80',
    featured: true,
    bestSeller: true,
    description: {
      pt: 'Caminhe onde Jesus caminhou. Visite Jerusalém, Belém, Nazaré, Mar da Galileia e muito mais.',
      en: 'Walk where Jesus walked. Visit Jerusalem, Bethlehem, Nazareth, Sea of Galilee and more.',
      es: 'Camina donde Jesús caminó. Visita Jerusalén, Belén, Nazaret, Mar de Galilea y más.'
    },
    highlights: [
      { pt: 'Via Sacra', en: 'Via Dolorosa', es: 'Vía Dolorosa' },
      { pt: 'Santo Sepulcro', en: 'Holy Sepulcher', es: 'Santo Sepulcro' },
      { pt: 'Monte das Oliveiras', en: 'Mount of Olives', es: 'Monte de los Olivos' },
      { pt: 'Rio Jordão', en: 'Jordan River', es: 'Río Jordán' },
      { pt: 'Mar Morto', en: 'Dead Sea', es: 'Mar Muerto' }
    ]
  },
  {
    id: 2,
    name: { pt: 'Fátima e Portugal', en: 'Fatima and Portugal', es: 'Fátima y Portugal' },
    destination: { pt: 'Portugal', en: 'Portugal', es: 'Portugal' },
    duration: 8,
    departure: 'brazil',
    price: 3200,
    image: 'https://images.unsplash.com/photo-1555881603-223f0f45e346?w=800&q=80',
    featured: true,
    bestSeller: true,
    description: {
      pt: 'Visite o Santuário de Fátima, onde Nossa Senhora apareceu aos três pastorzinhos.',
      en: 'Visit the Sanctuary of Fatima, where Our Lady appeared to the three shepherd children.',
      es: 'Visita el Santuario de Fátima, donde Nuestra Señora apareció a los tres pastorcitos.'
    },
    highlights: [
      { pt: 'Santuário de Fátima', en: 'Fatima Sanctuary', es: 'Santuario de Fátima' },
      { pt: 'Capelinha das Aparições', en: 'Chapel of Apparitions', es: 'Capilla de las Apariciones' },
      { pt: 'Casa dos Pastorzinhos', en: 'Shepherds House', es: 'Casa de los Pastorcitos' },
      { pt: 'Valinhos', en: 'Valinhos', es: 'Valinhos' },
      { pt: 'Convento de Cristo', en: 'Convent of Christ', es: 'Convento de Cristo' }
    ]
  },
  {
    id: 3,
    name: { pt: 'Itália Completa', en: 'Complete Italy', es: 'Italia Completa' },
    destination: { pt: 'Itália', en: 'Italy', es: 'Italia' },
    duration: 14,
    departure: 'brazil',
    price: 5500,
    image: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=800&q=80',
    featured: true,
    bestSeller: true,
    description: {
      pt: 'Roma, Assis, Pádua, Veneza, Florença e muito mais. A peregrinação completa pela Itália.',
      en: 'Rome, Assisi, Padua, Venice, Florence and more. The complete pilgrimage through Italy.',
      es: 'Roma, Asís, Padua, Venecia, Florencia y más. La peregrinación completa por Italia.'
    },
    highlights: [
      { pt: 'Audiência Papal', en: 'Papal Audience', es: 'Audiencia Papal' },
      { pt: 'Basílica de São Pedro', en: 'St. Peters Basilica', es: 'Basílica de San Pedro' },
      { pt: 'Túmulo de São Francisco', en: 'Tomb of St. Francis', es: 'Tumba de San Francisco' },
      { pt: 'Basílica de Santo Antônio', en: 'St. Anthony Basilica', es: 'Basílica de San Antonio' },
      { pt: 'Capela Sistina', en: 'Sistine Chapel', es: 'Capilla Sixtina' }
    ]
  },
  {
    id: 4,
    name: { pt: 'França Mariana', en: 'Marian France', es: 'Francia Mariana' },
    destination: { pt: 'França', en: 'France', es: 'Francia' },
    duration: 12,
    departure: 'brazil',
    price: 4800,
    image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800&q=80',
    featured: true,
    description: {
      pt: 'Lourdes, Paris, Lisieux, Nevers. Visite os santuários marianos da França.',
      en: 'Lourdes, Paris, Lisieux, Nevers. Visit the Marian shrines of France.',
      es: 'Lourdes, París, Lisieux, Nevers. Visita los santuarios marianos de Francia.'
    },
    highlights: [
      { pt: 'Gruta de Lourdes', en: 'Lourdes Grotto', es: 'Gruta de Lourdes' },
      { pt: 'Basílica de Santa Bernadette', en: 'St. Bernadette Basilica', es: 'Basílica de Santa Bernadette' },
      { pt: 'Basílica de Santa Teresinha', en: 'St. Therese Basilica', es: 'Basílica de Santa Teresita' },
      { pt: 'Capela da Medalha Milagrosa', en: 'Miraculous Medal Chapel', es: 'Capilla de la Medalla Milagrosa' },
      { pt: 'Notre Dame', en: 'Notre Dame', es: 'Notre Dame' }
    ]
  },
  {
    id: 5,
    name: { pt: 'Medjugorje', en: 'Medjugorje', es: 'Medjugorje' },
    destination: { pt: 'Bósnia e Herzegovina', en: 'Bosnia and Herzegovina', es: 'Bosnia y Herzegovina' },
    duration: 9,
    departure: 'brazil',
    price: 3500,
    image: 'https://images.unsplash.com/photo-1583037189850-1921ae7c6c22?w=800&q=80',
    featured: false,
    description: {
      pt: 'Visite o local das aparições de Nossa Senhora. Suba o Monte das Aparições e o Monte Krizevac.',
      en: 'Visit the site of Our Lady apparitions. Climb Mount Apparition and Mount Krizevac.',
      es: 'Visita el sitio de las apariciones de Nuestra Señora. Sube el Monte de las Apariciones y el Monte Krizevac.'
    },
    highlights: [
      { pt: 'Igreja de São Tiago', en: 'St. James Church', es: 'Iglesia de Santiago' },
      { pt: 'Monte das Aparições', en: 'Apparition Hill', es: 'Monte de las Apariciones' },
      { pt: 'Monte Krizevac', en: 'Mount Krizevac', es: 'Monte Krizevac' },
      { pt: 'Comunidade Cenáculo', en: 'Cenacle Community', es: 'Comunidad Cenáculo' },
      { pt: 'Adoração ao Santíssimo', en: 'Adoration', es: 'Adoración' }
    ]
  },
  {
    id: 6,
    name: { pt: 'Espanha e Santiago', en: 'Spain and Santiago', es: 'España y Santiago' },
    destination: { pt: 'Espanha', en: 'Spain', es: 'España' },
    duration: 11,
    departure: 'brazil',
    price: 4200,
    image: 'https://images.unsplash.com/photo-1543783207-ec64e4d95325?w=800&q=80',
    featured: false,
    description: {
      pt: 'Santiago de Compostela, Montserrat, Ávila, Salamanca. Os santuários da Espanha.',
      en: 'Santiago de Compostela, Montserrat, Avila, Salamanca. The shrines of Spain.',
      es: 'Santiago de Compostela, Montserrat, Ávila, Salamanca. Los santuarios de España.'
    },
    highlights: [
      { pt: 'Catedral de Santiago', en: 'Santiago Cathedral', es: 'Catedral de Santiago' },
      { pt: 'Mosteiro de Montserrat', en: 'Montserrat Monastery', es: 'Monasterio de Montserrat' },
      { pt: 'Convento de Santa Teresa', en: 'St. Teresa Convent', es: 'Convento de Santa Teresa' },
      { pt: 'Basílica de Pilar', en: 'Pilar Basilica', es: 'Basílica del Pilar' },
      { pt: 'Toledo Medieval', en: 'Medieval Toledo', es: 'Toledo Medieval' }
    ]
  },
  {
    id: 7,
    name: { pt: 'Grécia e Turquia', en: 'Greece and Turkey', es: 'Grecia y Turquía' },
    destination: { pt: 'Grécia e Turquia', en: 'Greece and Turkey', es: 'Grecia y Turquía' },
    duration: 13,
    departure: 'usa',
    price: 4500,
    image: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=800&q=80',
    featured: true,
    description: {
      pt: 'Nos passos de São Paulo. Atenas, Corinto, Éfeso, Patmos e as sete igrejas do Apocalipse.',
      en: 'In the steps of St. Paul. Athens, Corinth, Ephesus, Patmos and the seven churches of Revelation.',
      es: 'En los pasos de San Pablo. Atenas, Corinto, Éfeso, Patmos y las siete iglesias del Apocalipsis.'
    },
    highlights: [
      { pt: 'Casa da Virgem Maria', en: 'House of Virgin Mary', es: 'Casa de la Virgen María' },
      { pt: 'Éfeso Antigo', en: 'Ancient Ephesus', es: 'Éfeso Antiguo' },
      { pt: 'Ilha de Patmos', en: 'Island of Patmos', es: 'Isla de Patmos' },
      { pt: 'Acrópole de Atenas', en: 'Acropolis of Athens', es: 'Acrópolis de Atenas' },
      { pt: 'Meteora', en: 'Meteora', es: 'Meteora' }
    ]
  },
  {
    id: 8,
    name: { pt: 'México - Guadalupe', en: 'Mexico - Guadalupe', es: 'México - Guadalupe' },
    destination: { pt: 'México', en: 'Mexico', es: 'México' },
    duration: 6,
    departure: 'usa',
    price: 2200,
    image: 'https://images.unsplash.com/photo-1518638150340-f706e86654de?w=800&q=80',
    featured: true,
    bestSeller: true,
    description: {
      pt: 'Basílica de Nossa Senhora de Guadalupe, Cidade do México e pirâmides de Teotihuacán.',
      en: 'Basilica of Our Lady of Guadalupe, Mexico City and Teotihuacan pyramids.',
      es: 'Basílica de Nuestra Señora de Guadalupe, Ciudad de México y pirámides de Teotihuacán.'
    },
    highlights: [
      { pt: 'Basílica de Guadalupe', en: 'Guadalupe Basilica', es: 'Basílica de Guadalupe' },
      { pt: 'Manto de Juan Diego', en: 'Juan Diego Cloak', es: 'Manto de Juan Diego' },
      { pt: 'Teotihuacán', en: 'Teotihuacan', es: 'Teotihuacán' },
      { pt: 'Centro Histórico', en: 'Historic Center', es: 'Centro Histórico' },
      { pt: 'Catedral Metropolitana', en: 'Metropolitan Cathedral', es: 'Catedral Metropolitana' }
    ]
  },
  {
    id: 9,
    name: { pt: 'Polônia - João Paulo II', en: 'Poland - John Paul II', es: 'Polonia - Juan Pablo II' },
    destination: { pt: 'Polônia', en: 'Poland', es: 'Polonia' },
    duration: 9,
    departure: 'usa',
    price: 3800,
    image: 'https://images.unsplash.com/photo-1587974928442-77dc3e0dba72?w=800&q=80',
    featured: false,
    description: {
      pt: 'Nos passos de São João Paulo II. Varsóvia, Cracóvia, Wadowice, Auschwitz e Czestochowa.',
      en: 'In the footsteps of St. John Paul II. Warsaw, Krakow, Wadowice, Auschwitz and Czestochowa.',
      es: 'Siguiendo los pasos de San Juan Pablo II. Varsovia, Cracovia, Wadowice, Auschwitz y Czestochowa.'
    },
    highlights: [
      { pt: 'Casa natal de JP II', en: 'JP II Birthplace', es: 'Casa natal de JP II' },
      { pt: 'Santuário da Divina Misericórdia', en: 'Divine Mercy Sanctuary', es: 'Santuario de la Divina Misericordia' },
      { pt: 'Mosteiro de Jasna Góra', en: 'Jasna Gora Monastery', es: 'Monasterio de Jasna Góra' },
      { pt: 'Mina de Sal de Wieliczka', en: 'Wieliczka Salt Mine', es: 'Mina de Sal de Wieliczka' },
      { pt: 'Campo de Auschwitz', en: 'Auschwitz Camp', es: 'Campo de Auschwitz' }
    ]
  },
  {
    id: 10,
    name: { pt: 'Irlanda - São Patrício', en: 'Ireland - St. Patrick', es: 'Irlanda - San Patricio' },
    destination: { pt: 'Irlanda', en: 'Ireland', es: 'Irlanda' },
    duration: 10,
    departure: 'usa',
    price: 4100,
    image: 'https://images.unsplash.com/photo-1590508520532-42f13cae3485?w=800&q=80',
    featured: false,
    description: {
      pt: 'Dublin, Knock, Cliffs of Moher, Galway. Nos passos de São Patrício pela Irlanda.',
      en: 'Dublin, Knock, Cliffs of Moher, Galway. In the footsteps of St. Patrick through Ireland.',
      es: 'Dublín, Knock, Acantilados de Moher, Galway. Siguiendo los pasos de San Patricio por Irlanda.'
    },
    highlights: [
      { pt: 'Santuário de Knock', en: 'Knock Shrine', es: 'Santuario de Knock' },
      { pt: 'Catedral de São Patrício', en: 'St. Patrick Cathedral', es: 'Catedral de San Patricio' },
      { pt: 'Mosteiro de Glendalough', en: 'Glendalough Monastery', es: 'Monasterio de Glendalough' },
      { pt: 'Cliffs of Moher', en: 'Cliffs of Moher', es: 'Acantilados de Moher' },
      { pt: 'Rock of Cashel', en: 'Rock of Cashel', es: 'Roca de Cashel' }
    ]
  }
];

export const faqData = [
  {
    question: {
      pt: 'Quais são as formas de pagamento?',
      en: 'What are the payment methods?',
      es: '¿Cuáles son las formas de pago?'
    },
    answer: {
      pt: 'Após o pagamento do sinal (entre $300 e $500 dólares), o passageiro pode ir abatendo o restante da forma como preferir. Chegando 60 dias antes do embarque, pode dividir o restante em até 10x sem juros no cartão.',
      en: 'After paying the deposit (between $300 and $500 dollars), the passenger can pay the rest as they prefer. 60 days before departure, they can divide the rest in up to 10x interest-free on the card.',
      es: 'Después de pagar la señal (entre $300 y $500 dólares), el pasajero puede ir pagando el resto como prefiera. Llegando 60 días antes del embarque, puede dividir el resto en hasta 10x sin intereses en la tarjeta.'
    }
  },
  {
    question: {
      pt: 'O pagamento é feito em dólar ou em real?',
      en: 'Is payment made in dollars or reais?',
      es: '¿El pago se hace en dólares o en reales?'
    },
    answer: {
      pt: 'Os pacotes são fixados em dólar, porém o pagamento deve ser feito em real. No dia do pagamento, informe-se sobre o dólar da agência do dia.',
      en: 'Packages are set in dollars, but payment must be made in reais. On the day of payment, check the agency\'s dollar rate for the day.',
      es: 'Los paquetes están fijados en dólares, pero el pago debe hacerse en reales. El día del pago, infórmese sobre el dólar de la agencia del día.'
    }
  },
  {
    question: {
      pt: 'Quanto dinheiro devo levar?',
      en: 'How much money should I take?',
      es: '¿Cuánto dinero debo llevar?'
    },
    answer: {
      pt: 'Para pensão completa (café + almoço + jantar), recomendamos $20 dólares/euros por dia. Para meia pensão (café e jantar), recomendamos $30 dólares/euros por dia.',
      en: 'For full board (breakfast + lunch + dinner), we recommend $20 dollars/euros per day. For half board (breakfast and dinner), we recommend $30 dollars/euros per day.',
      es: 'Para pensión completa (desayuno + almuerzo + cena), recomendamos $20 dólares/euros por día. Para media pensión (desayuno y cena), recomendamos $30 dólares/euros por día.'
    }
  },
  {
    question: {
      pt: 'Preciso falar inglês?',
      en: 'Do I need to speak English?',
      es: '¿Necesito hablar inglés?'
    },
    answer: {
      pt: 'Não é necessário falar nenhum idioma extra. Você sempre estará acompanhado dos guias da Demarré Tours que fazem todos os processos da viagem.',
      en: 'It is not necessary to speak any extra language. You will always be accompanied by Demarré Tours guides who handle all travel processes.',
      es: 'No es necesario hablar ningún idioma extra. Siempre estará acompañado por los guías de Demarré Tours que hacen todos los procesos del viaje.'
    }
  },
  {
    question: {
      pt: 'Se eu cancelar, tenho reembolso?',
      en: 'If I cancel, do I get a refund?',
      es: 'Si cancelo, ¿tengo reembolso?'
    },
    answer: {
      pt: 'Sinal (US$ 500) retido em qualquer cancelamento. 60 a 31 dias antes do embarque: multa de 50%. 30 a 16 dias: multa de 70%. 15 dias ou menos: multa de 100%. No-show: perda total do valor.',
      en: 'Deposit ($500) retained on any cancellation. 60 to 31 days before departure: 50% penalty. 30 to 16 days: 70% penalty. 15 days or less: 100% penalty. No-show: total amount forfeited.',
      es: 'Señal (US$ 500) retenida en cualquier cancelación. 60 a 31 días antes del embarque: multa del 50%. 30 a 16 días: multa del 70%. 15 días o menos: multa del 100%. No-show: pérdida total del valor.'
    }
  }
];

export const companyInfo = {
  name: 'Demarré Tours',
  phone: '+55 21 99997-1248',
  whatsapp: '+55 21 99997-1248',
  whatsappUS: '+1 407 520-7083',
  email: 'info@demarretours.com',
  founded: 1996,
  founders: 'Marcos e Claudia Demarré',
  offices: {
    brazil: {
      name: { pt: 'Escritório Brasil', en: 'Brazil Office', es: 'Oficina Brasil' },
      address: 'Av. Armando Lombardi, 350 | Loja 130',
      city: 'Rio de Janeiro, RJ - Brasil',
      phone: '+55 21 99997-1248',
    },
    usa: {
      name: { pt: 'Escritório Estados Unidos', en: 'United States Office', es: 'Oficina Estados Unidos' },
      address: '7041 Grand National Dr ste. 111',
      city: 'Orlando, FL 32819',
      phone: '+1 407 520-7083',
    },
  },
  history: {
    pt: 'A Demarré Tours não é apenas uma empresa. Somos uma família. Essa família vem sendo formada há quase 30 anos por milhares de peregrinos que nos deram, e dão, a alegria de fazer parte de nossas viagens.',
    en: 'Demarré Tours is not just a company. We are a family. This family has been formed for almost 30 years by thousands of pilgrims who have given us, and continue to give us, the joy of being part of our trips.',
    es: 'Demarré Tours no es solo una empresa. Somos una familia. Esta familia se ha formado durante casi 30 años por miles de peregrinos que nos han dado, y nos dan, la alegría de formar parte de nuestros viajes.'
  },
  social: {
    facebook: 'https://www.facebook.com/share/1Aia3xYuNS/?mibextid=wwXIfr',
    instagram: 'https://www.instagram.com/demarre_tours?igsh=MWxvaHp1Z2ltc3gwNA==',
    youtube: 'https://www.youtube.com/@demarretours'
  }
};